import React from 'react';
import { motion } from 'framer-motion';

const testimonials = [
  {
    text: 'A qualidade dos vídeos é impressionante! Full HD real, dá pra ver cada detalhe da jogada. Meus alunos adoram rever os treinos.',
    image: 'https://randomuser.me/api/portraits/men/32.jpg',
    name: 'Roberto Silva',
    role: 'Arena MV',
  },
  {
    text: 'O suporte responde em minutos! Tive um problema num domingo e resolveram na hora. Atendimento nota 10.',
    image: 'https://randomuser.me/api/portraits/women/44.jpg',
    name: 'Fernanda Costa',
    role: 'Sagrada Beach',
  },
  {
    text: 'Mudei de sistema porque o anterior vivia dando problema. Desde que instalei a Apertai, zero dor de cabeça.',
    image: 'https://randomuser.me/api/portraits/men/45.jpg',
    name: 'Carlos Eduardo',
    role: 'Recreativo',
  },
  {
    text: 'As lives mudaram o jogo! Pais assistem os filhos jogando de casa, campeonatos ficaram muito mais profissionais.',
    image: 'https://randomuser.me/api/portraits/women/68.jpg',
    name: 'Ana Paula',
    role: 'X-Clone',
  },
  {
    text: 'Não paguei nada de instalação. Chegaram, montaram e em 30 minutos já estava gravando.',
    image: 'https://randomuser.me/api/portraits/men/51.jpg',
    name: 'Marcos Oliveira',
    role: 'Lagoa Beach',
  },
  {
    text: 'Meus clientes compartilham os vídeos nas redes sociais e isso traz gente nova pra arena. Virou marketing!',
    image: 'https://randomuser.me/api/portraits/women/53.jpg',
    name: 'Juliana Mendes',
    role: 'Caraíva Beach',
  },
  {
    text: 'A câmera grava os últimos 30 segundos automaticamente. É só apertar o botão e pronto — o lance já está salvo.',
    image: 'https://randomuser.me/api/portraits/men/22.jpg',
    name: 'Pedro Henrique',
    role: 'Duna Sports',
  },
  {
    text: 'Já são 2 anos com a Apertai e nunca pensei em trocar. Qualidade constante. Recomendo de olhos fechados.',
    image: 'https://randomuser.me/api/portraits/women/45.jpg',
    name: 'Luciana Barros',
    role: 'Renascença',
  },
  {
    text: 'O que mais me impressionou foi a velocidade. Grava, sobe pro site e já está disponível pro jogador.',
    image: 'https://randomuser.me/api/portraits/men/61.jpg',
    name: 'Thiago Martins',
    role: 'Sport Beach BH',
  },
];

const firstColumn = testimonials.slice(0, 3);
const secondColumn = testimonials.slice(3, 6);
const thirdColumn = testimonials.slice(6, 9);

function TestimonialsColumn({ testimonials: items, className, duration = 15 }: { testimonials: typeof testimonials; className?: string; duration?: number }) {
  return (
    <div className={className} style={{ overflow: 'hidden' }}>
      <motion.div
        animate={{ translateY: '-50%' }}
        transition={{ duration, repeat: Infinity, ease: 'linear', repeatType: 'loop' }}
        className="flex flex-col gap-5 pb-5"
      >
        {[0, 1].map((_, idx) => (
          <React.Fragment key={idx}>
            {items.map((t, i) => (
              <div
                key={i}
                className="p-6 rounded-2xl border border-zinc-800 bg-zinc-900/60 max-w-xs w-full"
              >
                <p className="text-zinc-400 text-sm leading-relaxed">"{t.text}"</p>
                <div className="flex items-center gap-2.5 mt-4">
                  <img
                    src={t.image}
                    alt={t.name}
                    className="h-9 w-9 rounded-full object-cover"
                    loading="lazy"
                  />
                  <div>
                    <p className="text-white text-sm font-medium leading-tight">{t.name}</p>
                    <p className="text-zinc-500 text-xs">{t.role}</p>
                  </div>
                </div>
              </div>
            ))}
          </React.Fragment>
        ))}
      </motion.div>
    </div>
  );
}

export default function TestimonialsSection() {
  return (
    <section className="relative py-16 md:py-24 overflow-hidden" style={{ backgroundColor: '#111111' }}>
      <div className="container mx-auto px-4 max-w-7xl">
        <div className="text-center mb-12">
          <div className="inline-block border border-zinc-800 rounded-lg px-4 py-1 text-zinc-400 text-sm mb-5">
            Depoimentos
          </div>
          <h2 className="text-3xl md:text-4xl font-bold tracking-tight text-white">
            Quem contrata, confia e permanece conosco
          </h2>
          <p className="mt-4 text-zinc-500 max-w-md mx-auto">
            Veja o que nossos parceiros dizem sobre a experiência Apertai
          </p>
        </div>

        <div
          className="flex justify-center gap-5 max-h-[600px] overflow-hidden"
          style={{ maskImage: 'linear-gradient(to bottom, transparent, black 15%, black 85%, transparent)' }}
        >
          <TestimonialsColumn testimonials={firstColumn} duration={18} />
          <TestimonialsColumn testimonials={secondColumn} className="hidden md:block" duration={22} />
          <TestimonialsColumn testimonials={thirdColumn} className="hidden lg:block" duration={20} />
        </div>
      </div>
    </section>
  );
}
